import { readSubscriberCountry } from '../utils/common';

export const postMessage = (route, params) => {
  const message = {
    type: 'event',
    data: {
      route,
      params,
    },
  };
  window.parent.postMessage(
    JSON.stringify(message),
    document.referrer || ASCENDON_ENV_CONFIG.mainUrl,
  );
  return message;
};

export const postMessageOfferFlow = (route, parameters) => {
  const userCountry = readSubscriberCountry();
  const params = {
    ...parameters,
    userCountry,
    event: parameters.eventName,
    selectedLanguage: parameters.language,
  };
  const message = {
    type: 'event',
    data: {
      route,
      params,
    },
  };
  window.parent.postMessage(
    JSON.stringify(message),
    document.referrer || ASCENDON_ENV_CONFIG.mainUrl,
  );
  return message;
};

export default postMessage;
